import React from "react";
import { Constants } from "../utils/constants";

const HActionButton = ({
  label,
  icon,
  variant = "primary",
  onClick,
  className = "",
  fullWidth = false,
  size = "default", // 'small', 'medium', 'default', 'large'
  disabled = false,
}) => {
  const baseClasses = `flex items-center justify-center rounded-md transition-colors ${disabled ? "opacity-50 pointer-events-none" : ""}`;

  // Size classes
  const sizeClasses = {
    small: "h-8 px-2 text-xs",
    medium: "h-9 px-3 text-sm",
    default: "h-10 px-3 sm:px-4",
    large: "py-3 px-4",
  };

  // Variant style determination
  let variantStyles = {};
  let variantClasses = "";

  if (variant === "primary") {
    variantClasses = "text-white";
    variantStyles = { backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR };
  } else if (variant === "secondary") {
    variantClasses = "bg-gray-200 text-gray-800 hover:bg-gray-300";
  } else if (variant === "outline") {
    variantClasses = "hover:opacity-80";
    variantStyles = {
      backgroundColor: `${Constants.HOST_EXPERIENCE_BASE_COLOR}15`,
      color: Constants.HOST_EXPERIENCE_BASE_COLOR,
      border: `1px solid ${Constants.HOST_EXPERIENCE_BASE_COLOR}30`,
    };
  }

  const widthClass = fullWidth ? "flex-1" : "";
  const iconOnlyClass = !label ? "p-2" : "";

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${sizeClasses[size]} ${widthClass} ${iconOnlyClass} ${className} min-w-0`}
      onClick={onClick}
      disabled={disabled}
      aria-label={typeof label === "string" ? label : "Button"}
      style={variantStyles}
    >
      {icon && <span className={`flex items-center justify-center flex-shrink-0 ${label ? "mr-2" : ""}`}>{icon}</span>}
      {label && (
        <span
          className={`${icon ? "hidden sm:inline" : "font-medium"} truncate overflow-hidden text-ellipsis whitespace-nowrap min-w-0`}
        >
          {label}
        </span>
      )}
    </button>
  );
};

export default HActionButton;
